import { html } from 'lit';
import { MegaMenuIconMap, MegaMenuItem, MegaMenuSection } from '../../../../ui/gzMegaMenu/types';
import { translateFn } from '../../../../utils/translator.helper';
import { MegaMenuAction } from './types';
import { MultiLevelListItem } from '../../../../ui/gzMultiLevelList/types';

export class MegaMenuHelper {
  public static getMegaMenuSections(): Array<MegaMenuSection> {
    return [
      {
        label: translateFn(`Configure`),
        icon: 'ds-icon-menu_configure',
        items: MegaMenuHelper.getConfigureItems(),
      },
      {
        label: translateFn(`Investigate`),
        icon: 'ds-icon-edr_panel_investigation',
        items: MegaMenuHelper.getInvestigateItems(),
      },
      {
        label: translateFn('Integrations'),
        icon: 'ds-icon-entity_AD',
        items: MegaMenuHelper.getIntegrationsItems(),
      },
    ];
  }

  public static getItemsForRightClickOverlay(items: Array<MegaMenuItem>): Array<MultiLevelListItem> {
    return items
      .filter(item => !item.disabled)
      .map((item: MegaMenuItem) => ({
        name: item.label,
        value: item.event,
        disabled: item.disabled,
      }));
  }

  public static getMegaMenuIconMap(): MegaMenuIconMap {
    return {
      'ds-icon-menu_configure': html`
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          slot="custom-svg"
        >
          <g clip-path="url(#clip0_3070_274)">
            <path
              fill="inherit"
              d="M31.8381 14.132C31.4521 11.086 30.2551 8.374 28.4751 6.15L28.4991 6.181L27.1671 7.513C28.5561 9.361 29.5121 11.611 29.8421 14.059L29.8501 14.132H31.8381ZM21.0261 23.354C21.1381 23.466 21.2921 23.536 21.4631 23.536C21.6341 23.536 21.7891 23.466 21.9001 23.354L23.1121 22.181C23.2241 22.069 23.2941 21.915 23.2941 21.744C23.2941 21.573 23.2241 21.418 23.1121 21.307L22.1181 20.293C22.6671 19.526 23.0751 18.618 23.2821 17.637L23.2901 17.59H24.7011C25.0411 17.58 25.3161 17.312 25.3371 16.976V16.974V15.304C25.3371 15.298 25.3371 15.291 25.3371 15.284C25.3371 14.944 25.0611 14.668 24.7211 14.668H23.3101C23.1291 13.633 22.7611 12.71 22.2391 11.895L22.2571 11.925L23.2711 10.951C23.3831 10.839 23.4531 10.685 23.4531 10.514C23.4531 10.343 23.3831 10.188 23.2711 10.077L22.0981 8.865C21.9861 8.753 21.8321 8.683 21.6611 8.683C21.4901 8.683 21.3351 8.753 21.2241 8.865L20.2101 9.859C19.4411 9.318 18.5351 8.911 17.5561 8.695L17.5061 8.686V7.235C17.5061 6.895 17.2301 6.619 16.8901 6.619H15.2011C15.1951 6.619 15.1881 6.619 15.1811 6.619C14.8411 6.619 14.5651 6.895 14.5651 7.235V8.646C13.5271 8.836 12.6051 9.218 11.7951 9.756L11.8221 9.739L10.8481 8.725C10.7361 8.613 10.5821 8.543 10.4111 8.543C10.2401 8.543 10.0851 8.613 9.97411 8.725L8.76211 9.937C8.65011 10.049 8.58011 10.203 8.58011 10.374C8.58011 10.545 8.65011 10.7 8.76211 10.811L9.75611 11.825C9.20711 12.592 8.79911 13.5 8.59211 14.481L8.58411 14.528H7.15311C6.81311 14.538 6.53811 14.806 6.51711 15.142V15.144V16.833C6.51711 17.177 6.79111 17.458 7.13211 17.469H8.54411C8.73811 18.506 9.11911 19.428 9.65511 20.24L9.63811 20.212L8.62411 21.186C8.51211 21.298 8.44211 21.452 8.44211 21.623C8.44211 21.794 8.51211 21.949 8.62411 22.06L9.79711 23.272C9.90911 23.384 10.0631 23.454 10.2341 23.454C10.4051 23.454 10.5601 23.384 10.6711 23.272L11.6851 22.278C12.4521 22.827 13.3601 23.235 14.3411 23.442L14.3881 23.45V24.861C14.3981 25.201 14.6661 25.476 15.0021 25.497H15.0041H16.6931C17.0371 25.497 17.3181 25.223 17.3291 24.882V23.47C18.3661 23.276 19.2881 22.895 20.1001 22.359L20.0721 22.376L21.0261 23.354ZM15.8581 21.366C12.9621 21.321 10.6311 18.963 10.6311 16.06C10.6311 13.129 13.0071 10.753 15.9381 10.753C18.8691 10.753 21.2451 13.129 21.2451 16.06C21.2451 16.074 21.2451 16.088 21.2451 16.101V16.099C21.2001 18.995 18.8421 21.326 15.9391 21.326C15.9391 21.326 15.9391 21.326 15.9381 21.326L15.8581 21.366ZM15.9381 1.988C19.1751 1.991 22.1571 3.082 24.5381 4.914L24.5051 4.889L25.8761 3.458C23.1861 1.303 19.7331 0 15.9751 0C15.9621 0 15.9491 0 15.9361 0H15.9381C7.76311 0.013 1.02211 6.141 0.0451094 14.054L0.0371094 14.132H2.02511C3.02911 7.255 8.86711 2.028 15.9341 1.988H15.9381ZM2.02511 17.888H0.0371094C0.987109 25.191 6.73411 30.903 13.9721 31.793L14.0501 31.801V29.813C7.83411 28.921 2.96911 24.09 2.03511 17.966L2.02511 17.888ZM29.8511 17.888C29.0001 24.146 24.1561 29.057 18.0041 30.002L17.9251 30.012V32C25.2571 31.04 30.9831 25.246 31.8311 17.963L31.8381 17.888H29.8511ZM18.7601 15.96C18.7601 17.519 17.4961 18.782 15.9381 18.782C14.3801 18.782 13.1161 17.518 13.1161 15.96C13.1161 14.401 14.3801 13.138 15.9381 13.138C17.4961 13.138 18.7601 14.402 18.7601 15.96Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_3070_274">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      `,
      'ds-icon-edr_panel_investigation': html`
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          slot="custom-svg"
        >
          <g clip-path="url(#clip0_3070_277)">
            <path
              d="M31.249 31.098C31.686 30.589 31.952 29.923 31.952 29.194C31.952 28.465 31.686 27.799 31.246 27.286L31.249 27.29L24.292 20.273C25.814 18.114 26.724 15.429 26.724 12.532C26.724 9.30705 25.596 6.34605 23.714 4.02105L23.734 4.04605C23.524 3.85005 23.242 3.72905 22.931 3.72905C22.745 3.72905 22.568 3.77205 22.412 3.85005L22.419 3.84705C22.221 4.06005 22.1 4.34605 22.1 4.66105C22.1 4.85105 22.144 5.03105 22.223 5.19005L22.22 5.18305C23.814 7.15105 24.779 9.68505 24.779 12.445C24.779 15.336 23.72 17.98 21.968 20.009L21.981 19.994L20.466 21.529C18.599 23.057 16.188 23.982 13.561 23.982C13.501 23.982 13.44 23.982 13.38 23.981H13.389C13.341 23.982 13.284 23.982 13.228 23.982C10.113 23.982 7.30403 22.674 5.32003 20.577L5.31503 20.572C3.22403 18.591 1.92203 15.794 1.92203 12.693C1.92203 12.589 1.92303 12.486 1.92603 12.384V12.399C1.92503 12.351 1.92503 12.295 1.92503 12.238C1.92503 9.09605 3.22303 6.25705 5.31203 4.22805L5.31503 4.22505C6.32403 3.32005 7.50703 2.58505 8.80503 2.07905L8.88303 2.05205C9.16103 1.83105 9.33703 1.49305 9.33703 1.11405C9.33703 0.964047 9.30903 0.821047 9.25903 0.688047L9.26203 0.696047C9.19303 0.297047 8.85003 -0.00195312 8.43603 -0.00195312C8.32403 -0.00195312 8.21703 0.0200469 8.12003 0.0600469L8.12603 0.0580469C6.53003 0.792047 5.17403 1.77805 4.04603 2.98105L4.04003 2.98805C1.58003 5.37505 0.0530254 8.71205 0.0530254 12.406C0.0530254 12.431 0.0530254 12.456 0.0530254 12.481V12.477C0.0520254 12.536 0.0510254 12.607 0.0510254 12.677C0.0510254 16.337 1.58003 19.64 4.03403 21.981L4.03903 21.986C6.44803 24.395 9.75503 25.906 13.416 25.973H13.429C13.434 25.973 13.44 25.973 13.447 25.973C16.006 25.973 18.391 25.23 20.399 23.948L20.347 23.979L27.484 31.195C27.944 31.689 28.598 31.997 29.324 31.997C30.097 31.997 30.788 31.648 31.249 31.099L31.252 31.095L31.249 31.098Z"
              fill="inherit"
            />
            <path
              d="M17.474 14.891V4.78402C18.335 4.42802 18.929 3.59502 18.929 2.62302C18.929 1.33502 17.885 0.291016 16.597 0.291016C15.309 0.291016 14.265 1.33502 14.265 2.62302C14.265 2.62602 14.265 2.62902 14.265 2.63202C14.265 2.63602 14.265 2.64102 14.265 2.64502C14.265 3.60602 14.851 4.43002 15.685 4.77902L15.7 4.78502V8.03402H12.112C11.772 7.15302 10.932 6.54002 9.94896 6.54002C8.67196 6.54002 7.63696 7.57502 7.63696 8.85202C7.63696 10.129 8.67196 11.164 9.94896 11.164C9.97296 11.164 9.99796 11.164 10.022 11.163H10.018C10.026 11.163 10.035 11.163 10.045 11.163C11.002 11.163 11.823 10.576 12.166 9.74302L12.172 9.72801H15.76V14.891C15.188 15.129 14.742 15.575 14.51 16.132L14.504 16.147H12.112C11.752 15.309 10.934 14.732 9.98096 14.732C8.70396 14.732 7.66896 15.767 7.66896 17.044C7.66896 18.321 8.70396 19.356 9.98096 19.356C9.99396 19.356 10.008 19.356 10.021 19.356C10.948 19.356 11.745 18.806 12.106 18.015L12.112 18.001H14.444C14.793 18.85 15.613 19.436 16.57 19.436C16.572 19.436 16.575 19.436 16.577 19.436C16.593 19.436 16.613 19.437 16.632 19.437C17.909 19.437 18.944 18.402 18.944 17.125C18.944 16.151 18.342 15.318 17.489 14.977L17.473 14.972L17.474 14.891Z"
              fill="inherit"
            />
          </g>
          <defs>
            <clipPath id="clip0_3070_277">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      `,
      'ds-icon-entity_AD': html` <svg width="32" height="32" viewBox="0 0 32 32" slot="custom-svg">
        <path
          d="M25.9799 12.7089C24.0399 12.7089 22.4669 14.2819 22.4669 16.2219C22.4709 16.8839 22.6579 17.5019 22.9799 18.0279L22.9709 18.0129L22.9619 17.9969L17.9149 23.0439C17.7369 22.9319 17.5309 22.8349 17.3139 22.7649L17.2949 22.7599H17.2749V9.47489C18.6849 8.99289 19.6819 7.67889 19.6819 6.13289C19.6819 4.18689 18.1039 2.60889 16.1579 2.60889C14.2119 2.60889 12.6339 4.18689 12.6339 6.13289C12.6339 7.67089 13.6189 8.97789 14.9919 9.45989L15.0169 9.46789L15.0409 9.47589V22.7559C14.7759 22.8429 14.5469 22.9479 14.3329 23.0759L14.3489 23.0669L14.3649 23.0589L9.25995 17.9199C9.54795 17.4419 9.71895 16.8639 9.71895 16.2469C9.71895 16.2429 9.71895 16.2389 9.71895 16.2359V16.2049C9.71895 14.2579 8.14095 12.6799 6.19395 12.6799C4.24695 12.6799 2.66895 14.2579 2.66895 16.2049C2.66895 18.1519 4.24695 19.7299 6.19395 19.7299H6.20595C6.74895 19.7289 7.26295 19.6059 7.72195 19.3859L7.70095 19.3949L7.67994 19.4039L12.9559 24.6869C12.7809 25.0929 12.6789 25.5659 12.6789 26.0619C12.6789 26.0659 12.6789 26.0709 12.6789 26.0749V26.0739C12.7939 27.9279 14.3249 29.3879 16.1979 29.3879C18.0669 29.3879 19.5959 27.9339 19.7159 26.0949L19.7169 26.0849V26.0369C19.7169 26.0359 19.7169 26.0349 19.7169 26.0329C19.7169 25.5329 19.6069 25.0589 19.4099 24.6329L19.4189 24.6539L19.4269 24.6749L24.6269 19.4949C25.0219 19.6699 25.4819 19.7719 25.9669 19.7719C25.9709 19.7719 25.9759 19.7719 25.9799 19.7719H26.0249C27.8759 19.6549 29.3339 18.1239 29.3339 16.2529C29.3339 14.3819 27.8769 12.8519 26.0359 12.7349L26.0259 12.7339L25.9799 12.7089Z"
          fill="inherit"
        />
      </svg>`,
    };
  }

  private static getConfigureItems(): Array<MegaMenuItem> {
    const configureItems: Array<MegaMenuItem> = [
      // Nice to have
      {
        label: translateFn(`Assign policy`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.ASSIGN_POLICY,
        isQuickAction: true,
        id: 'networkV2-assign-policy-button',
      },
      {
        label: translateFn(`Assign Security Servers`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.ASSIGN_SECURITY_SERVERS,
        isQuickAction: false,
        id: 'networkV2-assign-security-servers-button',
      },
      {
        label: translateFn('Assign tags'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.ASSIGN_TAGS,
        isQuickAction: true,
        id: 'networkV2-assign-tags-button',
      },
      {
        label: translateFn(`Install agent`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.INSTALL_AGENT,
        isQuickAction: true,
        id: 'networkV2-install-agent-button',
      },
      {
        label: translateFn(`Install patches`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.INSTALL_PATCHES,
        id: 'networkV2-install-patches-button',
      },
      {
        label: translateFn(`Isolate endpoint`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.ISOLATE_ENDPOINT,
        isQuickAction: false,
        id: 'networkV2-isolate-endpoint-button',
      },
      {
        label: translateFn(`Move`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.MOVE_TO,
        isQuickAction: false,
        id: 'networkV2-move-entities-button',
      },
      {
        label: translateFn(`Reconfigure agent`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.RECONFIGURE_AGENT,
        isQuickAction: true,
        id: 'networkV2-reconfigure-agent-button',
      },
      {
        label: translateFn(`Remove from isolation`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.REMOVE_FROM_ISOLATION,
        isQuickAction: false,
        id: 'networkV2-restore-from-isolation-button',
      },
      {
        label: translateFn(`Repair agent`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.REPAIR_AGENT,
        id: 'networkV2-repair-agent-button',
      },
      {
        label: translateFn(`Restart endpoint`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.RESTART_TASK,
        isQuickAction: false,
        id: 'networkV2-restart-task-button',
      },
      {
        label: translateFn('Resume integrity monitoring'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.RESUME_INTEGRITY_MONITORING,
        isQuickAction: false,
        id: 'networkV2-resume-integrity-monitoring-button',
      },
      {
        label: translateFn('Suspend integrity monitoring'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.SUSPEND_INTEGRITY_MONITORING,
        id: 'networkV2-suspend-integrity-monitoring-button',
      },
      {
        label: translateFn('Unassign tags'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.UNASSIGN_TAGS,
        isQuickAction: false,
        id: 'networkV2-unassign-tags-button',
      },
      {
        label: translateFn('Suspend protection'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.SUSPEND_PROTECTION,
        isQuickAction: false,
        id: 'networkV2-suspend-protection-button',
      },
      {
        label: translateFn('Resume protection'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.RESUME_PROTECTION,
        isQuickAction: false,
        id: 'networkV2-resume-protection-button',
      },
      {
        label: translateFn(`Uninstall agent`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.UNINSTALL_AGENT,
        id: 'networkV2-uninstall-agent-button',
      },
      {
        label: translateFn(`Update agent`),
        disabledMessage: translateFn(`This action is disabled`),
        event: MegaMenuAction.UPDATE_AGENT,
        isQuickAction: true,
        id: 'networkV2-update-agent-button',
      },
      {
        label: translateFn('Update Security Server'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.UPDATE_SECURITY_SERVER,
        id: 'networkV2-update-security-server-button',
      },
    ];

    return configureItems.filter((item: MegaMenuItem) => {
      switch (item.event) {
        case MegaMenuAction.INSTALL_PATCHES:
          return (
            Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_PATCH_MANAGEMENT_VISIBLE]) &&
            !Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_COMPANION_STANDALONE])
          );
        case MegaMenuAction.ASSIGN_POLICY:
          return Application.Main.hasAllRights([
            Constants.Rights.RIGHT_MANAGE_INVENTORY,
            Constants.Rights.RIGHT_MANAGE_POLICIES_READ,
          ]);
        case MegaMenuAction.ISOLATE_ENDPOINT:
        case MegaMenuAction.REMOVE_FROM_ISOLATION:
          return Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_ISOLATION_VISIBLE]);
        case MegaMenuAction.ASSIGN_TAGS:
        case MegaMenuAction.UNASSIGN_TAGS:
          return Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_TAGS_VISIBLE]);
        case MegaMenuAction.RESUME_INTEGRITY_MONITORING:
        case MegaMenuAction.SUSPEND_INTEGRITY_MONITORING:
          return Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_INTEGRITY_MONITOR_VISIBLE]);
        case MegaMenuAction.UPDATE_SECURITY_SERVER:
          return (
            Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING]) &&
            !Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_COMPANION_STANDALONE])
          );
        case MegaMenuAction.ASSIGN_SECURITY_SERVERS:
          return (
            Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_REMOTE_ENGINES_SHARING]) &&
            Application.Main.company.isPartner()
          );
        default:
          return true;
      }
    });
  }

  private static getInvestigateItems(): Array<MegaMenuItem> {
    const investigateItems: Array<MegaMenuItem> = [
      {
        label: translateFn(`Exchange scan`),
        event: MegaMenuAction.EXCHANGE_SCAN,
        id: 'networkV2-exchange-scan-button',
      },
      {
        label: translateFn(`Malware scan`),
        event: MegaMenuAction.MALWARE_SCAN,
        isQuickAction: true,
        disabledMessage: translateFn(`This action is disabled`),
        id: 'networkV2-malware-scan-button',
      },
      {
        label: translateFn('Run network discovery'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.RUN_NETWORK_DISCOVERY,
        isQuickAction: false,
        id: 'networkV2-run-network-discovery-button',
      },
      {
        label: translateFn('Remote shell'),
        event: MegaMenuAction.REMOTE_SHELL,
        disabledMessage: translateFn(`This action is disabled`),
        id: 'networkV2-remote-shell-button',
      },
      {
        label: translateFn('Risk scan'),
        event: MegaMenuAction.RISK_SCAN,
        id: 'networkV2-risk-scan-button',
      },
      {
        label: translateFn(`IOC scan`),
        event: MegaMenuAction.IOC_SCAN,
        id: 'networkV2-ioc-scan-button',
      },
      {
        label: translateFn(`Patch scan`),
        event: MegaMenuAction.PATCH_SCAN,
        disabledMessage: translateFn('This action is disabled'),
        id: 'networkV2-patch-scan-button',
      },
      {
        label: translateFn('Submit to Sandbox Analyzer'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.SUBMIT_TO_SANDBOX,
        id: 'networkV2-submit-to-sandbox-button',
      },
    ];

    return investigateItems.filter((item: MegaMenuItem) => {
      switch (item.event) {
        case MegaMenuAction.MALWARE_SCAN:
          return !Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_COMPANION_STANDALONE]);
        case MegaMenuAction.EXCHANGE_SCAN:
          return (
            Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_EXCHANGE]) &&
            !Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_COMPANION_STANDALONE])
          );
        case MegaMenuAction.PATCH_SCAN:
          return (
            Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_PATCH_MANAGEMENT_VISIBLE]) &&
            !Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_COMPANION_STANDALONE])
          );
        case MegaMenuAction.REMOTE_SHELL:
          return Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_REMOTE_ACCESS_VISIBLE]);
        case MegaMenuAction.IOC_SCAN:
          return (
            (Application.Main.company.isPartner() &&
              Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_EDR_INCIDENTS])) ||
            (Application.Main.company.isCustomer() &&
              Application.Main.hasFeatures([
                Constants.Features.PRODUCT_FEATURE_EDR_INCIDENTS,
                Constants.Features.PRODUCT_FEATURE_EDR_USABLE,
              ]))
          );
        case MegaMenuAction.RISK_SCAN:
          return Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_IOR_VISIBLE]);
        case MegaMenuAction.SUBMIT_TO_SANDBOX:
          return Application.Main.hasFeatures([Constants.Features.PRODUCT_FEATURE_SANDBOX_ANALYZER_VISIBLE]);
        default:
          return true;
      }
    });
  }

  private static getIntegrationsItems(): Array<MegaMenuItem> {
    const integrationsItems: Array<MegaMenuItem> = [
      {
        label: translateFn(`Set as AD Integrator`),
        event: MegaMenuAction.SET_AD_INTEGRATOR,
        disabledMessage: translateFn(`This action is disabled`),
        id: 'networkV2-set-ad-integrator-button',
      },
      {
        label: translateFn(`Remove AD Integrator`),
        event: MegaMenuAction.REMOVE_AD_INTEGRATOR,
        disabledMessage: translateFn(`This action is disabled`),
        id: 'networkV2-remove-ad-integrator-button',
      },
      {
        label: translateFn(`Remove AD Integration`),
        event: MegaMenuAction.REMOVE_AD_INTEGRATION,
        disabledMessage: translateFn(`This action is disabled`),
        id: 'networkV2-remove-ad-integration-button',
      },
      {
        label: translateFn('Sync with EC2'),
        event: MegaMenuAction.SYNC_WITH_EC2,
        disabledMessage: translateFn(`This action is disabled`),
        id: 'networkV2-sync-with-ec2-button',
      },
      {
        label: translateFn(`Mark as Golden Image`),
        event: MegaMenuAction.MARK_GOLDEN_IMAGE,
        disabledMessage: translateFn(`This action is disabled`),
        id: 'networkV2-mark-golden-image-button',
      },
      {
        label: translateFn('Unmark as Golden Image'),
        event: MegaMenuAction.UNMARK_GOLDEN_IMAGE,
        disabledMessage: translateFn(`This action is disabled`),
        id: 'networkV2-unmark-golden-image-button',
      },
      {
        label: translateFn('Assign vCenter integrator'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.ASSIGN_VCENTER_INTEGRATOR,
        id: 'networkV2-assign-vcenter-role-button',
      },
      {
        label: translateFn('Unassign vCenter integrator'),
        disabledMessage: translateFn('This action is disabled'),
        event: MegaMenuAction.UNASSIGN_VCENTER_INTEGRATOR,
        id: 'networkV2-unassign-vcenter-role-button',
      },
    ];

    // return integrationsItems;
    return integrationsItems.filter((item: MegaMenuItem) => {
      switch (item.event) {
        case MegaMenuAction.MARK_GOLDEN_IMAGE.toString():
        case MegaMenuAction.UNMARK_GOLDEN_IMAGE.toString():
          return Application.Main.hasGoldenImageModeEnabled();
        case MegaMenuAction.SET_AD_INTEGRATOR.toString():
          return Application.Main.product.isCloud();
        case MegaMenuAction.REMOVE_AD_INTEGRATOR.toString():
        case MegaMenuAction.REMOVE_AD_INTEGRATION.toString():
          return (
            Application.Main.product.isCloud() &&
            Application.Main.hasFeatures(Constants.Features.PRODUCT_FEATURE_AD_CLOUD_CONFIGURED)
          );
        case MegaMenuAction.SYNC_WITH_EC2:
          return (
            Application.Main.hasAnyRights([Constants.Rights.RIGHT_MANAGE_INVENTORY]) &&
            (Application.Main.company.isPartner() ||
              Application.Main.hasFeatures([
                Constants.Features.PRODUCT_FEATURE_AMAZON_EC2_CLOUD_INTEGRATION_CONFIGURED,
              ]))
          );
        case MegaMenuAction.ASSIGN_VCENTER_INTEGRATOR:
        case MegaMenuAction.UNASSIGN_VCENTER_INTEGRATOR:
          return (
            Application.Main.hasAnyRights([Constants.Rights.RIGHT_MANAGE_INVENTORY]) &&
            (Application.Main.company.isPartner() ||
              Application.Main.hasFeatures([
                Constants.Features.PRODUCT_FEATURE_VMWARE_SYNC_USABLE,
              ]))
          );
        default:
          return true;
      }
    });
  }
}
